import { render, staticRenderFns } from "./ShopListTwo.vue?vue&type=template&id=1d86e4a7&"
import script from "./ShopListTwo.vue?vue&type=script&lang=js&"
export * from "./ShopListTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d86e4a7')) {
      api.createRecord('1d86e4a7', component.options)
    } else {
      api.reload('1d86e4a7', component.options)
    }
    module.hot.accept("./ShopListTwo.vue?vue&type=template&id=1d86e4a7&", function () {
      api.rerender('1d86e4a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/shop/list/ShopListTwo.vue"
export default component.exports